import {
  apply, call, delay, put, select,
} from 'redux-saga/effects';

import { BettingSuggestionsEventsRequest } from 'bettingSuggestions-api';

import {
  getBSConfig, getMatchId, getBSInitialWaitOver, getIsOperator, getClientAlias, getLanguage,
} from 'reducers';
import {
  bettingSuggestionsAddProcessingEvent,
  bettingSuggestionsHideProcessingEvent, bettingSuggestionsRemoveProcessingEvent, bettingSuggestionsShowProcessingEvent,
} from 'actions/components';
import {
  BS_INITIAL_WAIT_TIME, BS_COOLDOWN_TIME, BS_DURATION_TIME, BS_TTL, BS_POLLING_INTERVAL,
} from 'constants/app';


function* loadBSEvents() {
  const hasBSConfig = yield select(getBSConfig);
  const BSInitialWaitOver = yield select(getBSInitialWaitOver);

  if (!hasBSConfig || !BSInitialWaitOver) {
    return;
  }

  const matchId = yield select(getMatchId);
  const isOperator = yield select(getIsOperator);
  const clientAlias = yield select(getClientAlias);
  const language = yield select(getLanguage);
  const request = new BettingSuggestionsEventsRequest(matchId, isOperator, clientAlias, language);
  const BSEvent = yield apply(request, request.get);

  if (BSEvent && BSEvent.timestamp) {
    const isEventExpired = Math.floor(Date.now() / 1000) >= (BSEvent.timestamp + BS_TTL);

    if (!isEventExpired) {
      if (!BSInitialWaitOver) {
        yield delay(BS_INITIAL_WAIT_TIME);
      }

      yield put(bettingSuggestionsAddProcessingEvent(BSEvent));
      yield put(bettingSuggestionsShowProcessingEvent());

      yield delay(BS_DURATION_TIME);

      yield put(bettingSuggestionsHideProcessingEvent());
      yield put(bettingSuggestionsRemoveProcessingEvent());

      yield delay(BS_COOLDOWN_TIME);
    }
  }
}

function* pollBSConfig(matchId) {
  for (;;) {
    try {
      yield call(loadBSEvents, matchId);
      yield delay(BS_POLLING_INTERVAL);
    } catch (error) {
      yield delay(BS_POLLING_INTERVAL);
    }
  }
}

export default pollBSConfig;
